<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <v-btn icon
             v-on="on"
             @click="emitsync"
             small>
        <v-icon v-on="on"
                size="20"
                :color="'warning'"
                v-text="'mdi-sync-alert'" />
      </v-btn>
    </template>
    {{$t('servicesystem.common_objects.fallbackterms.externally_changed')}}
  </v-tooltip>
</template>



<script>
export default {
  name: "ExternalChangeWarning",
  props: [],

  data() {
    return {};
  },

  mounted() {},

  methods: {
    emitsync() {
      //console.log("sync");
      this.$emit("Sync");
    },
  },

  computed: {},

  watch: {},
};
</script>